<template>
  <div>
    <v-form v-model="valid" lazy-validation>
      <v-container :class="ui.bkgdColor">
        <div>
          <v-layout row :class="ui.textSubheading">
            <div class="ml-4 mt-4">
              Order Requirements
            </div>
          </v-layout>
          <v-layout row wrap class="ml-2 mr-2">
            <v-flex xs12 md8 lg6>
              <v-text-field
              :change="updateFormChar()"
              v-model="localForm.spare"
              :rules="ruleNumberPositive"
              prepend-icon="tag"
              hint="min. spares"
              persistent-hint
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md8 lg6>
              <v-select
                :change="updateFormChar()"
                v-model="lead"
                :label="this.localForm.lead"
                :items="leadTimeOptions"
                color="wplblue0"
                prepend-icon="timelapse"
                hint="lead time"
                persistent-hint
              >
              </v-select>
            </v-flex>
          </v-layout>
          <v-layout row wrap class="ml-2 mr-2">
            <v-flex xs12 md8 lg6>
              <v-text-field
              :change="updateFormChar()"
              v-model="localForm.cost"
              :rules="ruleNumberPositive"
              prepend-icon="paid"
              hint="cost cost"
              :suffix="localForm.costu"
              persistent-hint
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md8 lg6>
              <v-text-field
              :change="updateFormChar()"
              v-model="localForm.carb"
              :rules="ruleNumberPositive"
              prepend-icon="co2"
              :suffix="localForm.carbu"
              hint="carbon cost"
              persistent-hint
              ></v-text-field>
            </v-flex>
          </v-layout>
        </div>
        <div>
          <v-layout row :class="ui.textSubheading">
            <div class="ml-4 mt-4">
              Obsolescence Details
            </div>
          </v-layout>
          <v-layout row wrap class="ml-2 mr-2">
            <v-flex xs12 md8 lg6>
              <v-select
              :change="updateFormChar()"
                v-model="avail"
                :label="this.localForm.avail"
                :items="materialAvailabilityOptions"
                color="wplblue0"
                prepend-icon="hourglass_empty"
                hint="availability"
                persistent-hint
              >
              </v-select>
            </v-flex>
            <v-flex xs12 md8 lg6>
              <v-select
              :change="updateFormChar()"
                v-model="supp"
                :label="this.localForm.supp"
                :items="materialSupplyOptions"
                color="wplblue0"
                prepend-icon="shopping_cart"
                hint="supplier"
                persistent-hint
              >
              </v-select>
            </v-flex>
          </v-layout>
          <v-layout row wrap class="ml-2 mr-2">
            <v-flex xs12 md8 lg6>
              <v-select
              :change="updateFormChar()"
                v-model="rep"
                :label="this.localForm.rep"
                :items="materialReplacementOptions"
                color="wplblue0"
                prepend-icon="upgrade"
                hint="replacement"
                persistent-hint
              >
              </v-select>
            </v-flex>
            <v-flex xs12 md8 lg6>
              <v-select
              :change="updateFormChar()"
                v-model="eng"
                :label="this.localForm.eng"
                :items="materialEngingeeringOptions"
                color="wplblue0"
                prepend-icon="plumbing"
                hint="install and commissioning"
                persistent-hint
              >
              </v-select>
            </v-flex>
          </v-layout>
        </div>
        <div>
          <v-layout row :class="ui.textSubheading">
            <div class="ml-4 mt-4">
              Order Requirements
            </div>
          </v-layout>
          <v-layout row wrap class="ml-3 mr-2 mt-4">
            <v-flex xs12>
              <v-textarea
              :change="updateFormChar()"
              :color="ui.textColor"
              :background-color="ui.btnColor"
              v-model="localForm.order"
              :disabled="false"
              :outline="true"
              :rules="ruleMustBeNotUndefinedANDLessThan2000"
              hint="material planning and addditional orders"
              auto-grow
              persistent-hint
              ></v-textarea>
            </v-flex>
          </v-layout>
        </div>
        <v-layout row class="mb-4">
        </v-layout>
        <v-layout row class="mb-4">
        </v-layout>
      </v-container>
    </v-form>
  </div>
</template>

<script>
import docRevsModFunctions from "@/document/revisions/mixins/docRevsModFunctions.js";
import ruleTextfield from "@/data/rules/mixins/rulesTextfield.js";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import materialOptions from "@/data/options/mixins/materialOptions.js";
import timeOptions from "@/data/options/mixins/timeOptions.js";

import { mapGetters } from "vuex";
export default {
  data() {
    return {
      valid: true,
      localForm: {
        spare: "",
        lead: "",
        avail: "",
        supp: "",
        cost: "",
        carb: "",
        costu: "",
        carbu: "",
        unload: "",
        load: "",
        care: "",
        order: ""
      },
      orgForm: {
        spare: "",
        lead: "",
        avail: "",
        supp: "",
        cost: "",
        carb: "",
        costu: "",
        carbu: "",
        unload: "",
        load: "",
        care: "",
        order: ""
      },
      lead: "",
      avail: "",
      supp: "",
      rep: "",
      eng: ""
    };
  },
  beforeMount() {
    // fix orginal data before change
    this.localForm.spare = this.getDetail.char.spare;
    this.localForm.lead = this.getDetail.char.lead;
    this.localForm.cost = this.getDetail.char.cost;
    this.localForm.costu = this.getDetail.char.costu;
    this.localForm.carb = this.getDetail.char.carb;
    this.localForm.carbu = this.getDetail.char.carbu;
    this.localForm.avail = this.getDetail.char.avail;
    this.localForm.rep = this.getDetail.char.rep;
    this.localForm.eng = this.getDetail.char.eng;
    this.localForm.order = this.getDetail.char.order;

    this.orgForm.spare = this.getDetail.char.spare;
    this.orgForm.lead = this.getDetail.char.lead;
    this.orgForm.cost = this.getDetail.char.cost;
    this.orgForm.costu = this.getDetail.char.costu;
    this.orgForm.carb = this.getDetail.char.carb;
    this.orgForm.carbu = this.getDetail.char.carbu;
    this.orgForm.avail = this.getDetail.char.avail;
    this.orgForm.rep = this.getDetail.char.rep;
    this.orgForm.eng = this.getDetail.char.eng;
    this.orgForm.order = this.getDetail.char.order;
  },
  watch: {
    avail() {
      this.localForm.avail = this.avail;
      this.updateFormChar();
    },
    rep() {
      this.localForm.rep = this.rep;
      this.updateFormChar();
    },
    eng() {
      this.localForm.eng = this.eng;
      this.updateFormChar();
    },
    lead() {
      this.localForm.lead = this.lead;
      this.updateFormChar();
    },
    supp() {
      this.localForm.supp = this.supp;
      this.updateFormChar();
    }
  },
  // eslint-disable-next-line
  mixins: [
    docRevsModFunctions,
    ruleTextfield,
    apptheme,
    materialOptions,
    timeOptions
  ],
  computed: {
    ...mapGetters(["getDetail", "getDetailChar", "getCurrentPage"])
  },
  methods: {
    updateFormChar() {
      let char = this.getDetailChar;
      // eslint-disable-next-line
      if (
        this.localForm.lead !== this.orgForm.lead &&
        this.localForm.lead !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.lead = this.localForm.lead;
        // basic
        char.lead = this.localForm.lead;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(4.17, 1); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.rep !== this.orgForm.rep &&
        this.localForm.rep !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.rep = this.localForm.rep;
        // basic
        char.rep = this.localForm.rep;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(4.17, 2); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.eng !== this.orgForm.eng &&
        this.localForm.eng !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.eng = this.localForm.eng;
        // basic
        char.eng = this.localForm.eng;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(4.17, 3); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.spare !== this.orgForm.spare &&
        this.localForm.spare !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.spare = this.localForm.spare;
        // basic
        char.spare = this.localForm.spare;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(4.17, 4); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.cost !== this.orgForm.cost &&
        this.localForm.cost !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.cost = this.localForm.cost;
        // basic
        char.cost = this.localForm.cost;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(4.17, 5); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.carb !== this.orgForm.carb &&
        this.localForm.carb !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.carb = this.localForm.carb;
        // basic
        char.carb = this.localForm.carb;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(4.17, 6); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.avail !== this.orgForm.avail &&
        this.localForm.avail !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.avail = this.localForm.avail;
        // basic
        char.avail = this.localForm.avail;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(4.17, 7); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.supp !== this.orgForm.supp &&
        this.localForm.supp !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.supp = this.localForm.supp;
        // basic
        char.supp = this.localForm.supp;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(4.17, 8); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }

      if (
        this.localForm.order !== this.orgForm.order &&
        this.localForm.order !== ""
      ) {
        // after the change re-assign new Local to Org
        this.orgForm.order = this.localForm.order;
        // basic
        char.order = this.localForm.order;
        this.$store.dispatch("changeDetailChar", char);
        this.saveDocumentRevMod(5.21, 9); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }
    }
  }
};
</script>
